class Debug {
    constructor(app) {
        this.app = app;
        if (!this.isDebug()) return;

        app.events.subscribe('EVENT_LOAD_TEASERS',(data) => {
            console.log('Debug EVENT_LOAD_TEASERS', data);
            //RTB тизеры текст делаем красный
            for (let i in data) {
                if (data[i].is_rtb === 1) {

                    // document.querySelector("[data-id='"+data[i].teaser_id+"']").style.setProperty("color", "red", "important");

                    setTimeout(() => {
                        console.log("data[i].teaser_id", data[i].teaser_id);
                        var elements = document.querySelectorAll("[data-id='"+data[i].teaser_id+"'] *");
                        for (let elem of elements) {

                            elem.style.setProperty("color", "red", "important");
                        }
                    }, 1000)

                }
            }

        });


        this.debugButton('config', window.config);
    }

    isDebug()
    {
        return this.app.query.DEBUG && this.app.query.DEBUG === "1";
    }

    teaserInfo(teaser) {
        let info = [];

        info.push(teaser.index || 0);
        info.push(teaser.position || 0);
        info.push(!!teaser.teaser_id_for_debug ? teaser.teaser_id_for_debug : 0);
        info.push( 'w:' + (teaser.debug_weight || 0));
        info.push( 'f:' + (teaser.debug_factor || 0));
        if (!!teaser.debug_data) {

            info.push( teaser.debug_data);

            //let debug_data = JSON.parse(teaser.debug_data);
            // info.push( 'ad_tag_id:' + debug_data.debug.ad_tag_id);
            // info.push( 'ad_tag_coeff:' + debug_data.debug.ad_tag_coeff);
        }
        info.push( teaser.title);


        return info.join(" | ")
    }


    debugButton(neme, object)
    {

        let button = document.createElement("button");
        button.textContent = neme;
        button.style.position = "fixed";
        button.style.bottom = '0px';
        button.style.zIndex = 200;
        button.addEventListener('click', () => {
            let debugTextarea = document.querySelector('#debugTextarea');
            if (!debugTextarea) {
                let textarea =  document.createElement("textarea");
                textarea.style.position = "fixed";
                textarea.style.top = '0px';
                textarea.style.zIndex = '199';
                textarea.style.width = '100%';
                textarea.style.height = '100vh';
                textarea.style.display = 'none';
                textarea.id='debugTextarea';

                document.body.prepend(textarea);
                debugTextarea = document.querySelector('#debugTextarea');
            }

            if(debugTextarea.style.display === 'none') {
                debugTextarea.style.display = 'block';
            } else {
                debugTextarea.style.display = 'none';
            }
            debugTextarea.value = JSON.stringify(object, "", 4);

            //alert(JSON.stringify(object, "", 4));
        });
        document.body.prepend(button);
    }


}

module.exports = Debug;